var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isValidProduct(_vm.product)
    ? _c(
        "button",
        {
          directives: [{ name: "ripple", rawName: "v-ripple" }],
          class: _vm.$product.product,
          on: {
            click: function($event) {
              return _vm.$emit("click")
            }
          }
        },
        [
          _c(
            "div",
            { class: _vm.$product.image },
            [
              _c("v-img", {
                attrs: { src: _vm.imageUrl, contain: "", "aspect-ratio": "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { class: _vm.$product.name }, [
            _vm._v("\n    " + _vm._s(_vm.name) + "\n  ")
          ]),
          _vm._v(" "),
          _vm.product.price
            ? _c("p", { class: _vm.$product.price }, [
                _vm._v(
                  "\n    $" +
                    _vm._s(_vm.getFormattedProductPrice(_vm.product.price)) +
                    "\n  "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.product.description
            ? _c("p", { class: _vm.$product.description }, [
                _vm._v("\n    " + _vm._s(_vm.product.description) + "\n  ")
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/shared/components/ProductCard.vue?vue&type=template&id=99f16da8&
// module id = null
// module chunks = 